var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_py-2" },
    [
      _c("external-login-actions", {
        staticClass: "_mb-3",
        attrs: { "return-url": _vm.returnUrl },
        on: { success: _vm.onLoginSuccess },
      }),
      _vm._v(" "),
      _c("login-form", {
        attrs: { "return-url": _vm.returnUrl },
        on: { success: _vm.onLoginSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }